/* eslint-disable no-console */
import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { connectAuthEmulator, firebaseAuth } from '@/shared/lib/firebase'
import { initSentry } from '@/shared/lib/sentry'
import { reportWebVitals } from '@/shared/lib/web-vitals'
import { ErrorBoundary } from '@/shared/ui/ErrorBoundary'
import { Provider } from './providers'

initSentry()

// Import auth test utilities in development mode
if (import.meta.env.VITE_ENV === 'development') {
  import('@/shared/lib/test/utils/auth.test.utils')
    .then(() => console.log('Auth test utilities loaded. Use window.__authTestUtils in console to test authentication scenarios'))
    .catch(error => console.error('Failed to load auth test utilities:', error))

  // Import Sentry test utilities in development mode
  import('@/shared/lib/test/sentry.test.utils')
    .then(() => console.log('Sentry test utilities loaded. Use window.__sentryTestUtils in console to test Sentry integration'))
    .catch(error => console.error('Failed to load Sentry test utilities:', error))
}

if (import.meta.env.VITE_ENABLE_FIREBASE_EMULATOR_AUTH === 'true') {
  // Connect to the Auth Emulator only when running locally
  // The port (9099) should match what firebase emulators:start uses
  connectAuthEmulator(firebaseAuth, 'http://localhost:9099')
  console.log('Firebase Auth Emulator connected!')
}

// Remove all registered service workers when app loads
// This is required as a sw was previously included in the build
// and it can cause issues with the app loading/updating
// Remove this after RELEASE
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      registration.unregister()
    })
  })
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

if (import.meta.env.VITE_ENABLE_MOCKS === 'true') {
  import('@/shared/lib/test/mocks/handlers-success/browser')
    .then(async ({ worker }) => {
      const started = await worker.start()

      // Make it available in the console for debugging
      globalThis.window.msw = { worker }

      if (started) {
        console.warn('MSW initialized. Use window.msw.worker in console to debug')
      } else {
        console.error('MSW failed to initialize. Mocks will not be available.')
      }
    })
    .then(() => {
      root.render(
        <StrictMode>
          <ErrorBoundary>
            <Provider />
          </ErrorBoundary>
        </StrictMode>,
      )
    })
} else {
  root.render(
    <StrictMode>
      <ErrorBoundary>
        <Provider />
      </ErrorBoundary>
    </StrictMode>,
  )
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
